import React from "react";
import axios from "axios";

const useAssignmentData = (id) => {
    const [assignmentData, setAssignmentData] = React.useState({data: [], status: undefined});

    React.useEffect(() => {
        setAssignmentData(prevState => ({...prevState, status: 'processing'}));

        axios.get(`/tasks/${id}.json`).then((response) => {
            const responseData = response && response.data && response.data.name;

            if (responseData) {
                setAssignmentData({data: response.data, status: 'completed'});
            } else {
                setAssignmentData({data: [], status: 'failed'});
            }
        }).catch(() => {
            setAssignmentData(prevState => ({...prevState, status: 'failed'}));
        });
    }, [id]);

    return {
        data: assignmentData.data.tasks,
        name: assignmentData.data.name,
        status: assignmentData.status
    }
}

export default useAssignmentData;